import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";


export class FreespinOutro implements SimplePresentation {

    name: string = "FreespinOutro";

    constructor() {

    }

    shouldRun(): boolean {
        return DevilsCrossRoad.model.data.mode == GameMode.FREESPIN && DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.NORMAL && !DevilsCrossRoad.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();

        tl.add(() => {
            controller.setSkipCallback();
        });
        tl.add(() => {
            DevilsCrossRoad.keypadPlugin.hide();
            DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(-1);
        });

        tl.add(DevilsCrossRoad.transitionScreenView.showOutro(DevilsCrossRoad.model.gameData.accumulatedRoundWin));

        tl.add(() => {
            DevilsCrossRoad.keypadPlugin.show();
            DevilsCrossRoad.keypadPlugin.setWin(DevilsCrossRoad.model.gameData.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake())
        });

        tl.add(DevilsCrossRoad.transitionScreenView.enableButton(() => this.onButtonClick(controller)),"<");

    }

    private onButtonClick(controller: SimplePresentationRunnerController) {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            //DeadCanary.soundPlayer.fadeOutMusic(150);

             DevilsCrossRoad.keypadPlugin.show();
            DevilsCrossRoad.freespinUnlockAreas.resetEyeAnimations();
        });
        tl.add(DevilsCrossRoad.transitionScreenView.hideOutro());

        tl.add(() => controller.finish());

    }

}